const COIN_PURCHASE_RETURN_URL_KEY = "flowchestCoinPurchaseReturnUrl";

/** Remember where the user started before coin checkout. */
export function setCoinPurchaseReturnUrl(url: string | null | undefined): void {
  const value = (url || "").trim();
  if (value) {
    sessionStorage.setItem(COIN_PURCHASE_RETURN_URL_KEY, value);
  } else {
    sessionStorage.removeItem(COIN_PURCHASE_RETURN_URL_KEY);
  }
}

export function getCoinPurchaseReturnUrl(): string | null {
  return sessionStorage.getItem(COIN_PURCHASE_RETURN_URL_KEY);
}

export function clearCoinPurchaseReturnUrl(): void {
  sessionStorage.removeItem(COIN_PURCHASE_RETURN_URL_KEY);
}

export function resolveCoinPurchaseReturnUrl(
  preferred?: string | null
): string | null {
  const value = (preferred || getCoinPurchaseReturnUrl() || "").trim();
  return value || null;
}
